import React from 'react';

function hasMessage<T extends { message?: string }>(
  obj: T
): obj is T & { message: string } {
  return typeof obj.message === 'string';
}

function hasCode<T extends { code?: string }>(
  obj: T
): obj is T & { code: string } {
  return typeof obj.code === 'string';
}

export type ErrorDetailsProps = {
  error: unknown;
};

export const ErrorDetails = ({ error }: ErrorDetailsProps) => {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  return (
    <div className="space-y-1">
      {hasCode(error) && (
        <p>
          <span className="font-medium">Error code: </span>
          {error.code}
        </p>
      )}
      {hasMessage(error) && <p className="font-medium">{error.message}</p>}
    </div>
  );
};
